// Real client reviews — update this file to add/remove reviews
// These pull through automatically on the barber profile and landing pages

export const REVIEWS = [
  {
    id: 1,
    text: "Christian is the absolute best. I have been going to him for my hair and beard for about 4 years now. He is thorough, listens well and makes great recommendations. I would absolutely recommend him for your haircut!",
    name: "Bob Frink",
    service: null,
    date: "",
    source: "Google",
    rating: 5,
  },
  {
    id: 2,
    text: "Always happy to see Christian! He is prompt, does excellent work, space is super clean! He is the only one I let cut my hair!",
    name: "Verified Client",
    service: "Flair Classic",
    date: "Mar 2026",
    source: "Booksy",
    rating: 5,
  },
  {
    id: 3,
    text: "My kids look forward to going to the barber now because he is not heavy handed. They love their haircuts. We will be back.",
    name: "Verified Client",
    service: "Kids Cut",
    date: "Feb 2026",
    source: "Booksy",
    rating: 5,
  },
  {
    id: 4,
    text: "Going to a new barbershop can be scary for most men. But going to Christian was refreshing. Being in the hands of a trusted barber with years of experience.",
    name: "Verified Client",
    service: "Flair Classic",
    date: "Jan 2026",
    source: "Booksy",
    rating: 5,
  },
  {
    id: 5,
    text: "Great barber highly recommend, very professional and experienced.",
    name: "Anonymous",
    service: null,
    date: "",
    source: "Google",
    rating: 5,
  },
  {
    id: 6,
    text: "Amazing stylist never disappoints.",
    name: "Verified Client",
    service: "Flair Classic",
    date: "Mar 2026",
    source: "Booksy",
    rating: 5,
  },
  {
    id: 7,
    text: "Fantastic experience. Service is always A1.",
    name: "Verified Client",
    service: "Kids Cut",
    date: "Feb 2026",
    source: "Booksy",
    rating: 5,
  },
  {
    id: 8,
    text: "He always gives a quality style no matter what new haircut they request.",
    name: "Anonymous",
    service: null,
    date: "",
    source: "Google",
    rating: 5,
  },
];

// The best 3 for the barber landing page testimonials
export const FEATURED_BARBER_TESTIMONIALS = [
  REVIEWS[0], // Bob Frink - Google
  REVIEWS[1], // Always happy - Booksy
  REVIEWS[3], // New barbershop scary - Booksy
];

// The best 4 for the client barber profile page
export const FEATURED_CLIENT_REVIEWS = [
  REVIEWS[0],
  REVIEWS[1],
  REVIEWS[2],
  REVIEWS[3],
];
